module.exports = __webpack_public_path__ + "static/img/loginlogoenglish.737dcf2.png";